import { render } from "./PhoneInput.vue?vue&type=template&id=3c62262a"
import script from "./PhoneInput.vue?vue&type=script&lang=ts"
export * from "./PhoneInput.vue?vue&type=script&lang=ts"

import "./PhoneInput.vue?vue&type=style&index=0&id=3c62262a&lang=scss"
script.render = render

export default script